import { getApiAddress } from '@/core/apiConfig';
import { LicensePermissionDTO } from './permissionsDto';

export const DECORATOR_PERMISSIONS_ENDPOINT = 'decorator-permissions/v1';

export class PermissionsApi {
  static async getMyLicensePermission(): Promise<LicensePermissionDTO[]> {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const url = `${getApiAddress()}/${DECORATOR_PERMISSIONS_ENDPOINT}/licenses/me`;

    try {
      const response = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: myHeaders,
      });

      const { status } = response;

      if (status < 200 || status >= 400) {
        throw new Error(status.toString());
      }

      return await response.json();
    } catch (err) {
      console.error(err);
    }
  }

  static async sendInvitation({
    orgId,
    email,
    role,
    permission,
  }: {
    orgId: string;
    email: string;
    role: string;
    permission: string;
  }): Promise<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    try {
      await fetch(`${getApiAddress()}/${DECORATOR_PERMISSIONS_ENDPOINT}/invitations`, {
        body: JSON.stringify({
          orgId,
          email,
          role,
          permission,
          message: '',
        }),
        credentials: 'include',
        headers,
        method: 'POST',
      });
    } catch (error) {
      console.error('Error sending invitation', error);
      throw error;
    }
  }

  static async getUserPermissions(orgId: string) {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const url = `${getApiAddress()}/${DECORATOR_PERMISSIONS_ENDPOINT}/licenses/org/${orgId}`;
    const response = await fetch(url, {
      credentials: 'include',
      method: 'GET',
      headers: myHeaders,
    })
      .then(response => {
        return response.json();
      })
      .catch(error => {
        console.error('Error fetching user permissions');
        throw error;
      });
    return response;
  }

  static async updateUserPermission(
    userId: string,
    permission: string,
    orgId: string,
  ): Promise<boolean> {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const url = `${getApiAddress()}/${DECORATOR_PERMISSIONS_ENDPOINT}/licenses`;
    const body = { permission, userId, orgId };

    try {
      const response = await fetch(url, {
        credentials: 'include',
        method: 'PUT',
        headers: myHeaders,
        body: JSON.stringify(body),
      });

      const { status } = response;

      if (status < 200 || status >= 400) {
        throw new Error(status.toString());
      }

      return true;
    } catch (err) {
      console.error('Error updating user permission:', err);
      return false;
    }
  }

  static async inactiveUserPermission(userId: string, orgId: string) {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    await fetch(
      `${getApiAddress()}/${DECORATOR_PERMISSIONS_ENDPOINT}/licenses/org/${orgId}/user/${userId}`,
      {
        method: 'DELETE',
        headers: myHeaders,
        credentials: 'include',
      },
    ).catch(error => {
      console.error('Error inactive user', error);
      throw error;
    });
  }

  static async getOrgInvitations(orgId: string): Promise<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    try {
      const response = await fetch(
        `${getApiAddress()}/${DECORATOR_PERMISSIONS_ENDPOINT}/invitations/org/${orgId}`,
        {
          credentials: 'include',
          headers,
          method: 'GET',
        },
      );

      return response.json();
    } catch (error) {
      console.error('Error fetching invitations', error);
      throw error;
    }
  }

  static async deleteInvitation(orgId: string, email: string) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    await fetch(
      `${getApiAddress()}/${DECORATOR_PERMISSIONS_ENDPOINT}/invitations/org/${orgId}/user/${email}`,
      {
        method: 'DELETE',
        headers,
        credentials: 'include',
      },
    ).catch(error => {
      console.error('Error deleting invitation', error);
      throw error;
    });
  }
}
